<template>
    <v-data-table
        :total-items="total"
        :pagination="table.content.pagination"
        :headers="table.content.headers"
        :items="table.content.body"
        :search="table.content.search"
        sort-icon="keyboard_arrow_down"
        class="table-list"
        hide-actions
    >
        <template #headers="props">
            <tr>
                <template v-for="(header, key) in props.headers">
                    <th
                        v-if="!header.inner_items && table.content.pagination"
                        :key="key"
                        :class="['column',
                                 header.sort ? 'sortable' : '',
                                 table.content.pagination.descending ? 'desc' : 'asc',
                                 header.value === table.content.pagination.sortBy ? 'active' : ''
                        ]"
                        @click="change_sort(header.value, header.sort)"
                    >
                        {{ $t(header.text) }}
                        <v-icon v-if="header.sort" small>keyboard_arrow_up</v-icon>
                    </th>
                    <th
                        v-else
                        :key="key"
                        :colspan="header.inner_items.length"
                        class="pa-0"
                    >
                        <table width="100%">
                            <tr>
                                <th :colspan="header.inner_items.length" class="text-xs-center">
                                    {{ $t(header.text) }}
                                </th>
                            </tr>
                            <tr style="width: 100%">
                                <th
                                    v-for="(header_item, index) in header.inner_items"
                                    :key="index"
                                    :style="`width: ${100 / header.inner_items.length}%`"
                                    :class="[
                                        'column grey-bg',
                                        header_item.sort ? 'sortable' : '',
                                        table.content.pagination.descending ? 'desc' : 'asc',
                                        header_item.value === table.content.pagination.sortBy ? 'active' : ''
                                    ]"
                                    @click="change_sort(header_item.value, header_item.sort)"
                                >
                                    {{ $t(header_item.text) }}
                                    <v-icon v-if="header_item.sort" small>keyboard_arrow_up</v-icon>
                                </th>
                            </tr>

                        </table>
                    </th>
                </template>
            </tr>
        </template>
        <template #items="props">
            <tr>
                <template v-for="(header, key) in table.content.headers">
                    <td
                        v-if="!header.inner_items || !header.inner_items.length"
                        :key="key + header.value"
                        class="text-xs-left px-0"
                        @click="goto(props.item)"
                    >
                        <div class="link link--no-decor default-text">
                            <div v-if="(typeof props.item[header.value] != 'string') && (header.value === 'name')" class="px-4">
                                {{ props.item[header.value][0] }}
                                <div class="grey-text">{{ props.item[header.value][1] }}</div>
                            </div>
                            <div v-else-if="['status'].includes(header.value)" class="px-4">{{ $t(props.item[header.value]) }}</div>
                            <div v-else class="px-4">{{ header.value === 'date' ? get_date(props.item[header.value]) : props.item[header.value] }} </div>
                        </div>
                    </td>
                    <td
                        v-for="(inner_header, innerKey) in header.inner_items"
                        :key="key + header.value + inner_header.value + innerKey"
                        :style="`width: ${computedColumnWidth}%`"
                    >
                        <div v-if="props.item[header.value]" class="link link--no-decor default-text">
                            <div v-if="['status'].includes(inner_header.value)" class="px-4">
                                {{ $t(props.item[header.value][inner_header.value]) }}
                            </div>
                            <div v-else class="px-4">
                                {{ inner_header.value === 'date'
                                    ? get_date(props.item[header.value][inner_header.value])
                                : props.item[header.value][inner_header.value] }}
                            </div>
                        </div>
                    </td>
                </template>
            </tr>
        </template>
        <div v-if="table.content.search !== ''" slot="no-results" :value="true"
             color="error" icon="warning" class="body-2"
        >
            По запросу "{{ table.content.search }}" ничего не найдено.
        </div>
        <div slot="no-data" :value="true" color="error"
             icon="warning" class="body-2"
        >
            {{ $t("По запросу ничего не найдено.") }}
        </div>
    </v-data-table>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  props: {
    table: {
      type    : Object,
      required: true,
    },
    type: {
      type: String,
    },
    disable_pagination: {
      type   : Boolean,
      default: false,
    },

    total: {
      default: undefined,
    },
    request: {
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters('employee_study', [
      'employee_study_modal',
      'course_stat_modal',
      'tab',
      'total_stats',
    ]),
    ...mapGetters('employee_study/directorate', [
      'example_directorate',
    ]),
    ...mapGetters('employee_study/organizations', [
      'example_organization',
    ]),
    ...mapGetters('employee_study/users', [
      'example_user',
    ]),
    computedColumnWidth() {
      const headers = this.table.content.headers;
      const totalColumns = headers.reduce((sum, header) => {
        if (header.inner_items && Array.isArray(header.inner_items)) {
          return sum + header.inner_items.length;
        }
        return sum + 1;
      }, 0);

      // Возвращаем процентное значение для одной колонки
      return 100 / (totalColumns);
    },

    pagination: {
      get() {
        return this.table.content.pagination;
      },
      set($event) {
        if (this.type === 'directorate') {
          return this.SET_DIRECTORATE_PAGINATION($event);
        } else if (this.type === 'organizations') {
          return this.SET_ORG_PAGINATION($event);
        } else if (this.type === 'users') {
          return this.SET_USERS_PAGINATION($event);
        } else if (this.type === 'courses') {
          return this.SET_COURSES_PAGINATION($event);
        } else if (this.type === 'courses_summary') {
          return this.SET_COURSES_SUMMARY_PAGINATION($event);
        } else if (this.type === 'courses_business_plus_summary') {
          return this.SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGINATION($event);
        } else if (this.type === 'courses_verification') {
          return this.SET_COURSES_VERIFICATION_PAGINATION($event);
        }
      },
    },
  },
  methods: {
    get_date(date) {
      return new dayjs(parseInt(date)).utc().format('DD.MM.YYYY');
    },
    ...mapMutations('employee_study', [
      'OPEN_MODAL',
      'SET_ACTIVE_TAB',
      'SET_CURRENT_DEPARTMENT',
      'SET_CURRENT_COMPANY',
      'SET_CURRENT_USER',
      'SET_CURRENT_COURSE',
    ]),

    ...mapActions('employee_study', [
      'get_users',
      'get_companies',
      'get_courses',
      'get_courses_summary',
      'get_courses_business_plus_summary',
      'get_courses_verification',
    ]),

    ...mapMutations('employee_study/directorate', [
      'SET_DIRECTORATE_PAGINATION',
      'CHANGE_DIRECTORATE_SORT',
    ]),
    ...mapMutations('employee_study/organizations', [
      'SET_ORG_PAGINATION',
      'SET_ORG_PAGE',
      'CHANGE_ORG_SORT',
    ]),
    ...mapMutations('employee_study/users', [
      'SET_USERS_PAGINATION',
      'SET_USERS_PAGE',
      'CHANGE_USERS_SORT',
    ]),
    ...mapMutations('employee_study/courses', [
      'SET_COURSES_PAGINATION',
      'CHANGE_COURSES_SORT',
    ]),
    ...mapMutations('employee_study/coursesSummary', [
      'SET_COURSES_SUMMARY_PAGE',
      'CHANGE_COURSES_SUMMARY_SORT',
    ]),
    ...mapMutations('employee_study/coursesBusinessPlusSummary', [
      'SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE',
      'CHANGE_COURSES_BUSINESS_PLUS_SUMMARY_SORT',
    ]),
    ...mapMutations('employee_study/coursesVerification', [
      'SET_COURSES_VERIFICATION_PAGE',
      'CHANGE_COURSES_VERIFICATION_SORT',
    ]),
    get_request_params() {
      return {
        filter:
          {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
        page         : this.table.content.pagination.page,
        perPage      : this.table.content.pagination.rowsPerPage,
        business_plus: this.table.content.business_plus
      };
    },
    change_sort(column, isSort) {
      if (!isSort) return;
      if (this.type === 'directorate') {
        return this.CHANGE_DIRECTORATE_SORT(column);
      } else if (this.type === 'organizations') {
        this.CHANGE_ORG_SORT(column);
        this.SET_ORG_PAGE(1);
        this.get_companies(this.get_request_params());
      } else if (this.type === 'users') {
        this.CHANGE_USERS_SORT(column);
        this.SET_USERS_PAGE(1);
        this.get_users(this.get_request_params());
      } else if (this.type === 'courses_summary') {
        this.CHANGE_COURSES_SUMMARY_SORT(column);
        this.SET_COURSES_SUMMARY_PAGE(1);
        this.get_courses_summary(this.get_request_params());
      } else if (this.type === 'courses_business_plus_summary') {
        this.CHANGE_COURSES_BUSINESS_PLUS_SUMMARY_SORT(column);
        this.SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE(1);
        this.get_courses_business_plus_summary(this.get_request_params());
      } else if (this.type === 'courses_verification') {
        this.CHANGE_COURSES_VERIFICATION_SORT(column);
        this.SET_COURSES_VERIFICATION_PAGE(1);
        this.get_courses_verification(this.get_request_params());
      } else if (this.type === 'courses') {
        return this.CHANGE_COURSES_SORT(column);
      }
    },
    goto(value) {
      if (this.tab==='directorate') { // управления (4 вкладки)
        let current_department = this.total_stats.filter_departments.find((item)=>item.id==value.organization_id);
        if (current_department && value.organization_id!=0) {
          this.SET_CURRENT_DEPARTMENT(current_department);
          localStorage.setItem('current_department', JSON.stringify(current_department));
          this.$router.push({name  : 'employee_study_organizations',
            params: {
              directorate: 'orgs',
            },
            query: {
              directorate: value.organization_id,
            }});
        }

        // запрос на получение организаций этого управления
      }
      if (this.tab=='organizations' && this.$route.params.directorate) { // организации (3 вкладки) this.$route.params.directorate
        let current_company = this.total_stats.filter_company.find((item)=>item.id==value.company_id);
        if (current_company && value.company_id!=0) {
          this.SET_CURRENT_COMPANY(current_company);
          localStorage.setItem('current_company', JSON.stringify(current_company));
          this.$router.push({name  : 'employee_study_users', params: {
            organization: 'users',
            directorate : this.$route.params.directorate,
          },
          query: {
            directorate : this.$route.query.directorate, // получить с бэка управление в данной организации
            organization: value.company_id,
          }});
        }

        // запрос на получение пользователей этой организации этого управления
      } else if (this.tab=='organizations' && !this.$route.params.directorate) {
        let current_company = this.total_stats.filter_company.find((item)=>item.id==value.company_id);
        if (current_company && value.company_id!=0) {
          this.SET_CURRENT_COMPANY(current_company);
          localStorage.setItem('current_company', JSON.stringify(current_company));
          this.$router.push({name  : 'employee_study_users', params: {
            organization: 'users',
            directorate : 'orgs', // тут должно быть id управления этой организации
          },
          query: {
            directorate : 0, // получить с бэка id управления в данной организации
            organization: value.company_id,
          }});
        }

        // запрос на получение пользователей этой организации и запрос на её управление
      }
      if (this.tab=='courses' && this.$route.query.user) {
        this.SET_CURRENT_COURSE(value.course_id); // курсы this.$route.params.user && this.$route.params.organization && this.$route.params.directorate
        this.OPEN_MODAL('employee_study_modal');
      } else if (this.tab=='courses' && !this.$route.query.user) {
        this.SET_CURRENT_COURSE(value.course_id);
        this.OPEN_MODAL('course_stat_modal');
      }
      if (this.tab=='users' && this.$route.params.organization && this.$route.params.directorate) {
        this.SET_CURRENT_USER(value.user_id);
        localStorage.setItem('current_user', JSON.stringify(value.user_id));
        // пользователи (2 вкладки) this.$route.params.organization && this.$route.params.directorate
        this.$router.push({name  : 'employee_study_courses', params: {
          user        : 'courses',
          directorate : this.$route.params.directorate,
          organization: this.$route.params.organization,
        },
        query: {
          directorate : this.$route.query.directorate,
          organization: this.$route.query.organization,
          user        : value.user_id,
        }});
        this.SET_ACTIVE_TAB('courses');
        // запрос на получение курсов этого пользователя этой организации этого управления
      } else if (this.tab=='users' && this.$route.params.organization && !this.$route.params.directorate) {
        this.SET_CURRENT_USER(value.user_id);
        localStorage.setItem('current_user', JSON.stringify(value.user_id));
        this.$router.push({name  : 'employee_study_courses', params: {
          user        : 'courses',
          directorate : 'orgs', // получить с бэка управление у этого юзера
          organization: this.$route.params.organization,
        },
        query: {
          directorate : this.example_user.directorate.id, // получить с бэка управление по id юзера
          organization: this.$route.query.organization,
          user        : value.user_id,
        }});
        this.SET_ACTIVE_TAB('courses');
        // запрос на получение курсов этого пользователя этой организации и запрос на её управление
      } else if (this.tab=='users' && !this.$route.params.organization && this.$route.params.directorate) {
        this.SET_CURRENT_USER(value.user_id);
        localStorage.setItem('current_user', JSON.stringify(value.user_id));
        this.$router.push({name  : 'employee_study_courses', params: {
          user        : 'courses',
          directorate : this.$route.params.directorate,
          organization: 'users',
        },
        query: {
          directorate : this.$route.query.directorate,
          organization: this.example_user.organization.id, // получить с бэка организацию у этого юзера
          user        : value.user_id,
        }});
        this.SET_ACTIVE_TAB('courses');
        // запрос на получение курсов этого пользователя этого управления и запрос на его организацию
      } else if (this.tab === 'users' || this.tab === 'courses_summary') {
        this.SET_CURRENT_USER(value.user_id);
        localStorage.setItem('current_user', JSON.stringify(value.user_id));
        this.$router.push({name  : 'employee_study_courses', params: {
          user        : 'courses',
          directorate : 'orgs',
          organization: 'users',
        },
        query: {
          directorate : this.example_user.directorate.id, // получить с бэка управление у этого юзера
          organization: this.example_user.organization.id, // получить с бэка организацию у этого юзера
          user        : value.user_id,
        }});
        this.SET_ACTIVE_TAB('courses');
        // запрос на получение курсов этого пользователя и запрос на его организацию и управление
      }
    },
  },
};
</script>
